import {adicRestApi, adicRestApiAuthUrl} from '../index';

export const getAdicAccessToken = async (provider, accessToken) => {
  const url = adicRestApiAuthUrl
    .segment("/access-token")
    .query(
      {
        provider: provider
      }
    )
    .toString();
  adicRestApi.defaults.headers.common["Authorization"] = "Bearer " + (accessToken || "");
  try {
    const { data } = await adicRestApi.get(url);
    // if (adicRestApi.defaults.headers.common) {
    //   delete adicRestApi.defaults.headers.common["Authorization"];
    // }
    return data;
  } catch (e) {
    return null;
  }
};

export const getAdicUserInfo = async (provider) => {
  const url = adicRestApiAuthUrl
    .segment("/:provider/me")
    .param(
      {
        provider: provider
      }
    )
    .toString();
  try {
    const { data } = await adicRestApi.get(url);
    return data;
  } catch (e) {
    return null;
  }
};

export const signOutAuth = async (provider) => {
  const url = adicRestApiAuthUrl
    .segment("/sign-out")
    .param(
      {
        provider: provider
      }
    )
    .toString();
  try {
    const { data } = await adicRestApi.get(url);
    return data;
  } catch (e) {
    return null;
  }
};
